import ReactPixel from 'react-facebook-pixel';

ReactPixel.init('997416724525198');

export default ReactPixel;